import { Request } from './Request';

export interface IRunRecommendationsTrainerParams {
}

export interface IRunRecommendationsTrainerResult {
}

export class RunRecommendationsTrainerRequest extends Request<IRunRecommendationsTrainerParams, IRunRecommendationsTrainerResult> {
  constructor(params: IRunRecommendationsTrainerParams = {}) {
    super('runRecommendationsTrainerTask', params);
  }
}
